import React from 'react';
import styles from './NavLink.module.scss';

function NavLink(props) {
  return (
    <a
      className={styles.link}
      href={`#${props.container}`}
      onClick={() => props.handleClick()}
    >
      {props.title}
    </a>
  );
}

export default NavLink;